import PropTypes from 'prop-types';
import React from 'react';

import {ENCODING_STATUS_ENDED} from '@constants/variables';
import {Alert} from '@ui';

export const EventContentEncodingWarningMessage = ({encodingStatus = null}) => {
    return (
        <Alert
            icon={false}
            severity={ENCODING_STATUS_ENDED === encodingStatus ? 'warning' : 'error'}
        >
            The encoding configuration of this content has been modified since its last encoding was started.
            {
                (ENCODING_STATUS_ENDED === encodingStatus)
                    ? `
                        You can reset and restart the encoding in the Live Control page to encode with the 
                        new configuration.
                    `
                    : `
                        To encode with the new configuration, you need to stop the encoding, reset it and start it 
                        again in the Live Control page.
                    `
            }
        </Alert>
    );
};

EventContentEncodingWarningMessage.propTypes = {
    encodingStatus: PropTypes.number,
};

EventContentEncodingWarningMessage.displayName = 'EventContentEncodingWarningMessage';
